import React, { useState } from 'react';

import './RegisterForm.scss';
import images from '../../shared/assets/images';

import { link } from '../../helpers/link';
import { validate, resetStyles } from '../../helpers/form';

import VerificationCodeForm from '../VerificationCodeForm/VerificationCodeForm.jsx';

const { logo } = images;

export default function RegisterForm(props) {
  const [verificationCodeStage, nextStage] = useState(false);

  return verificationCodeStage ? (
    <VerificationCodeForm />
  ) : (
    <section id="register">
      <div id="register_logo">
        <img alt="logo" src={logo} />
      </div>

      <h2 id="register_title">Account aanmaken</h2>

      <form
        name="register"
        id="register_form"
        autoComplete="off"
        onSubmit={(e) => createAccount(e)}
        onKeyDown={(e) => resetStyles(e.target)}
      >
        <label htmlFor="register_username">Gebruikersnaam</label>
        <input
          autoFocus
          type="text"
          name="username"
          id="register_username"
          placeholder="Gebruikersnaam..."
        />

        <label htmlFor="register_fullname">Volledige naam</label>
        <input
          type="text"
          name="fullname"
          id="register_fullname"
          placeholder="Volledige naam"
        />

        <label htmlFor="register_email">Email</label>
        <input
          type="email"
          name="email"
          id="register_email"
          placeholder="email@email.com"
        />

        <label htmlFor="register_phone">Mobiel</label>
        <input
          type="tel"
          name="phone"
          id="register_phone"
          placeholder="+31 06 …"
        />

        <label htmlFor="register_password">Wachtwoord</label>
        <input
          type="password"
          name="password"
          id="register_password"
          placeholder="Kjge78xr..."
        />

        <label htmlFor="register_repeat_password">Wachtwoord herhalen</label>
        <input
          type="password"
          name="repeatPassword"
          id="register_repeat_password"
          placeholder="Kjge78xr..."
        />

        <label htmlFor="register_address">Adres</label>
        <input
          type="text"
          name="address"
          id="register_address"
          placeholder="Straat en huisnummer..."
        />

        <label htmlFor="register_postcode">
          Postcode (eerste vier cijfers)
        </label>
        <input
          type="number"
          name="postcode"
          id="register_postcode"
          placeholder="0000..."
        />

        <input name="terms" type="checkbox" id="register_terms_checkbox" />
        <label htmlFor="register_terms_checkbox">
          Ik ga akkoord met de{' '}
          {link(<span>algemene voorwaarden</span>, '#', props.nextLink)} van
          zwangerenportaal.nl
        </label>

        <div id="register_button">
          <button tabIndex="0" type="submit">
            Account aanmaken
          </button>
        </div>

        <div id="register_info">
          <div>
            <p id="register_info_title">Je gegevens zijn veilig bij ons</p>

            <p>Wachtoord vergeten?</p>
            <p>Gebruikersnaam vergeten?</p>

            {link(<p>Inloggen</p>, '/login', props.nextLink)}
          </div>

          <div>
            <p>Algemene voorwaarden</p>
            <p>Privacy statement</p>
          </div>
        </div>
      </form>
    </section>
  );

  function createAccount(e) {
    e.preventDefault();

    return (location.href = '/onboarding');

    const {
      terms,
      email,
      phone,
      address,
      postcode,
      username,
      fullname,
      password,
      repeatPassword
    } = document.register;

    const isValidated = validate(
      terms,
      email,
      phone,
      address,
      postcode,
      username,
      fullname,
      password,
      repeatPassword
    );

    if (!isValidated) return;

    // TODO: proceed account creation

    nextStage(true);
  }
}
